/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type ApplicationReviewStateMixQueryVariables = Types.Exact<{
  clientId: Types.Scalars['UUID']['input'];
}>;


export type ApplicationReviewStateMixQuery = { __typename: 'Query', applicationReviewStateMix?: { __typename: 'ApplicationReviewStateMixType', discovered: number, evaluating: number, approved: number, unapproved: number, totalCount: number } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const ApplicationReviewStateMixDocument = new TypedDocumentString(`
    query ApplicationReviewStateMix($clientId: UUID!) {
  applicationReviewStateMix(clientId: $clientId) {
    discovered
    evaluating
    approved
    unapproved
    totalCount
  }
}
    `);

export const useApplicationReviewStateMixQuery = <
      TData = ApplicationReviewStateMixQuery,
      TError = unknown
    >(
      variables: ApplicationReviewStateMixQueryVariables,
      options?: Omit<UseQueryOptions<ApplicationReviewStateMixQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ApplicationReviewStateMixQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ApplicationReviewStateMixQuery, TError, TData>(
      {
    queryKey: ['ApplicationReviewStateMix', variables],
    queryFn: fetcher<ApplicationReviewStateMixQuery, ApplicationReviewStateMixQueryVariables>(ApplicationReviewStateMixDocument, variables),
    ...options
  }
    )};

useApplicationReviewStateMixQuery.getKey = (variables: ApplicationReviewStateMixQueryVariables) => ['ApplicationReviewStateMix', variables];

export const useInfiniteApplicationReviewStateMixQuery = <
      TData = InfiniteData<ApplicationReviewStateMixQuery>,
      TError = unknown
    >(
      variables: ApplicationReviewStateMixQueryVariables,
      options: Omit<UseInfiniteQueryOptions<ApplicationReviewStateMixQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<ApplicationReviewStateMixQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<ApplicationReviewStateMixQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['ApplicationReviewStateMix.infinite', variables],
      queryFn: (metaData) => fetcher<ApplicationReviewStateMixQuery, ApplicationReviewStateMixQueryVariables>(ApplicationReviewStateMixDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteApplicationReviewStateMixQuery.getKey = (variables: ApplicationReviewStateMixQueryVariables) => ['ApplicationReviewStateMix.infinite', variables];


useApplicationReviewStateMixQuery.fetcher = (variables: ApplicationReviewStateMixQueryVariables) => fetcher<ApplicationReviewStateMixQuery, ApplicationReviewStateMixQueryVariables>(ApplicationReviewStateMixDocument, variables);
